import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import Page from '../../components/Page';
import { buildQuickFilterOptions } from '../../components/search/util';
import LoadingSpinner from '../../components/Spinner';
import { Statuses } from '../../constants/statuses';
import { setCurrentPage } from '../../redux/modules/app';
import { insuredListSearch, unmountInsuredListSearch } from '../../redux/modules/insuredList';

import InsuredsPageBody from './components/InsuredsPageBody';
import InsuredsPageHeader from './components/InsuredsPageHeader';
import quickFilters from './quickFilters';

const InsuredsPage = () => {
  const { companyId } = useParams();
  const dispatch = useDispatch();
  const insuredListLoading = useSelector(insuredListSearch.selectIsLoading);

  useEffect(() => {
    dispatch(setCurrentPage('insureds'));
    dispatch(insuredListSearch.setColumns([
      {
        accessor: 'insured',
        sortKey: 'company_name.keyword',
        sortName: 'companyName'
      },
      {
        accessor: 'external_id',
        sortKey: 'external_id',
        sortName: 'insuredExternalId'
      },
      {
        accessor: 'email',
        disableSortBy: true
      },
      {
        accessor: 'insurance_requirements',
        sortKey: 'overall_status.keyword',
        sortName: 'overallStatus'
      }
    ]));

    dispatch(insuredListSearch.setBaseFilters([
      { key: 'company.id', value: companyId },
      { key: 'status.keyword', value: [Statuses.Approved, Statuses.NotApproved] }
    ]));

    dispatch(insuredListSearch.setQuickFilterOptions(buildQuickFilterOptions(quickFilters, {})));

    dispatch(insuredListSearch.updateSortBy([{
      id: 'insured',
      desc: false
    }]));

    dispatch(insuredListSearch.getPage());

    return () => dispatch(unmountInsuredListSearch());
  }, []);

  return (
    <Page fixedHeight backgroundColor="grey" dusk="insureds-page">
      <InsuredsPageHeader searchBlueprint={insuredListSearch} />
      {!insuredListLoading
        ? <InsuredsPageBody searchBlueprint={insuredListSearch} />
        : <LoadingSpinner />}
    </Page>
  );
};

export default InsuredsPage;
